import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const resources = {
    sv: {
        translation: {
            site: {
                title: 'Finance Lab App',
                nav: {
                    menuSection: 'Meny',
                    overview: 'Överblick',
                    issues: 'Emissioner',
                    warrants: 'Teckningsoptioner',
                    convertibles: 'Konvertibler',
                    companies: 'Bolag',
                    advisors: 'Rådgivare',
                    statistics: 'Statistik',
                    news: 'Nyheter',
                    calendar: 'Kalender',
                    reports: 'Rapporter',
                    settingsSection: 'Inställningar',
                    support: 'Support',
                    contact: 'Kontakta oss',
                    help: 'Hjälp',
                    feedback: 'Feedback',
                    adminSection: 'Admin',
                    adminDashboard: 'Dashboard',
                    adminCustomers: 'Kunder',
                    adminUsers: 'Användare',
                    adminPRInput: 'PM Indata',
                    adminDelistings: 'Avnoteringar',
                    adminIssues: 'Emissioner',
                    adminIssuesReview: 'Avstämning',
                    adminIssuesNew: 'Ny Emission',
                    adminCompanies: 'Bolag',
                    adminCompaniesNew: 'Nytt Bolag',
                    adminWarrants: 'Teckningsoptioner',
                    adminWarrantsNew: 'Ny Teckningsoption',
                    adminConvertibles: 'Konvertibler',
                    adminConvertiblesNew: 'Ny Konvertibel',
                    adminInvestors: 'Investerare',
                    adminKeywordFilter: 'Keyword Filter',
                },
                auth: {
                    loginPrompt: 'Logga in för att fortsätta',
                    login: 'Logga in',
                    logout: 'Logga ut',
                    email: 'E-postadress',
                    password: 'Lösenord',
                    rememberMe: 'Kom ihåg mig',
                    forgotPassword: 'Glömt lösenord?',
                },
                convertibles: {
                    previous: 'Genomförda',
                    current: 'Pågående',
                    future: 'Kommande',
                    detailsTitle: 'Konvertibel {{name}}',
                },
                instruments: {
                    bankruptcy: 'Konkurs',
                    liquidation: 'Likvidation',
                    merger: 'Fusion',
                    acquisition: 'Uppköp',
                    changed_marketplace: 'Byte av marknadsplats',
                    voluntary_delisting: 'Frivillig avnotering',
                    lack_of_compliance: 'Ej uppfyllda noteringskrav',
                    redemption: 'Inlösen',
                },
                issues: {
                    previous: 'Genomförda',
                    current: 'Pågående',
                    future: 'Kommande',
                    detailsTitle: 'Emission {{name}}',
                },
                warrants: {
                    detailsTitle: 'Teckningsoption {{name}}',
                },
                companies: {
                    detailsTitle: 'Bolag: {{name}}',
                },
                advisors: {
                    detailsTitle: 'Rådgivare: {{name}}',
                },
            },
            entities: {
                issue: {
                    singular: 'Emission',
                    plural: 'Emissioner',
                    fields: {
                        id: 'Id',
                        shareId: 'Aktie',
                        recordDate: 'Avstämningsdag',
                        incRightsDate: 'Datum inkl rätter',
                        exRightsDate: 'Datum exkl rätter',
                        rightsStartDate: 'Rätter start handel',
                        rightsEndDate: 'Rätter slut handel',
                        subStartDate: 'Teckningsperiod start',
                        subEndDate: 'Teckningsperiod slut',
                        ipoTradingDate: 'Första handelsdag',
                        outstandingShares: 'Utestående antal aktier',
                        offeredUnits: 'Erbjudna units',
                        rightsRequired: 'Rätter som krävs',
                        unitsReceived: 'Units som erhålls',
                        sharesInUnit: 'Aktier per unit',
                        unitSubPrice: 'Teckningspris per unit',
                        approxCommitment: 'Åtagande (ca)',
                        approxGuarantor: 'Garanterat (ca)',
                        overAllotmentSize: 'Övertilldelning volym',
                        overAllotmentAllocation: 'Övertilldelning tilldelat',
                        internalComment: 'Intern kommentar',
                        externalComment: 'Extern kommentar',
                        unitSubTotal: 'Units tecknade',
                        unitSubWithRights: 'Units tecknade med rätter',
                        unitSubWithoutRights: 'Units tecknade utan rätter',
                        unitSubGuarantor: 'Units tecknade av garanter',
                        unitGuaranteeFee: 'Units erhållna som arvode',
                        generalMeetingDate: 'Bolagsstämma',
                        isinRights: 'ISIN för rätter',
                        isinUnits: 'ISIN för units',
                        cancelled: 'Avbruten',
                        approxTotalCommitment: 'Totalt åtagande (ca)',
                        sharesRequired: 'Aktier som krävs',
                        rightsReceived: 'Rätter som erhålls',
                        unitPctSubWithRights: 'Units tecknade med rätter (%)',
                        unitPctSubWithoutRights: 'Units tecknade utan rätter (%)',
                        unitPctSubGuarantor: 'Units tecknade av garanter (%)',
                    },
                },
                issueType: {
                    singular: 'Emissionstyp',
                    plural: 'Emissionstyper',
                    values: {
                        'ABB Directed issue': 'Riktad emission (ABB)',
                        'Directed issue': 'Riktad emission',
                        'Guarantor fee issue': 'Garantiersättning',
                        IPO: 'IPO',
                        'Non-cash issue': 'Apportemission',
                        // Other: 'Övrigt',
                        'Rights issue': 'Företrädesemission',
                    },
                },
                warrant: {
                    singular: 'Teckningsoption',
                    plural: 'Teckningsoptioner',
                    fields: {
                        id: 'Id',
                        issueId: 'Emission',
                        name: 'Namn på teckningsoption',
                        subStartDate: 'Teckningsperiod start',
                        subEndDate: 'Teckningsperiod slut',
                        vwapDiscount: 'VWAP rabatt',
                        vwapDays: 'VWAP-beräkning i dagar',
                        vwapPeriodEnd: 'VWAP-beräkning sista datum',
                        numberOfWarrants: 'Minimum teckningskurs',
                        priceMin: 'Minimum teckningskurs',
                        priceMinQuota: 'Kvotvärde minimum teckningskurs',
                        priceMax: 'Maximal teckningskurs',
                        isinWarrant: 'ISIN för teckningsoptionen',
                        warrantsRequired: 'Teckningsoptioner som krävs',
                        sharesReceived: 'Aktier som erhålls',
                        sharesSubscribed: 'Antal tecknade aktier',
                        internalComment: 'Intern kommentar',
                        externalComment: 'Extern kommentar',
                        warrantsPerUnit: 'Teckningsoptioner per unit',
                        commitments: 'Teckningsåtagande',
                        guarantors: 'Garantiåtagande',
                        warrantSubPrice: 'Teckningskurs',
                    },
                },
                company: {
                    singular: 'Bolag',
                    plural: 'Bolag',
                    fields: {
                        id: 'Id',
                        name: 'Namn',
                        ticker: 'Ticker',
                        isin: 'ISIN',
                        website: 'Hemsida',
                        sector: 'Sektor',
                        industry: 'Bransch',
                        description: 'Beskrivning',
                        logo: 'Logotyp',
                    },
                },
                news: {
                    singular: 'Nyhet',
                    plural: 'Nyheter',
                    fields: {
                        id: 'Id',
                        title: 'Rubrik',
                        content: 'Innehåll',
                        date: 'Datum',
                    },
                },
                investor: {
                    singular: 'Investerare',
                    plural: 'Investerare',
                },
                convertible: {
                    singular: 'Konvertibel',
                    plural: 'Konvertibler',
                    fields: {
                        conversion: 'Konvertering',
                        repayment: 'Återbetalning',
                        offset: 'Kvittning',
                    },
                },
            },
        },
    },
}

// en: {
//   translation: {
//     Search: "Search topics…",
//     "Welcome back": "Welcome back",
//     "We've missed you": "We've missed you",
//   },
// },
// fr: {
//   translation: {
//     Search: "Rechercher…",
//     "Welcome back": "Bon retour",
//     "We've missed you": "Tu nous as manqué",
//   },
// },
// de: {
//   translation: {
//     Search: "Suchen…",
//     "Welcome back": "Willkommen zurück",
//     "We've missed you": "Wir haben dich vermisst",
//   },
// },
// nl: {
//   translation: {
//     Search: "Zoeken…",
//     "Welcome back": "Welkom terug",
//     "We've missed you": "We hebben je gemist",
//   },
// },
// };

i18n.use(initReactI18next).init({
    resources,
    lng: 'sv',
    fallbackLng: 'sv',
    interpolation: {
        escapeValue: false,
    },
})
